import { Helper } from './../../shared/helper';
import { Component, OnInit, Input  } from '@angular/core';
import { UserService } from '../user.service';
import { IUser } from '../user';
import { environment } from '../../../environments/environment';
import { IBranch } from '../../branches/branch';
import { FormGroup, FormBuilder } from '@angular/forms';
import { BranchService } from '../../branches/branch.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { UserComponent } from '../single/user.component';

@Component({
  templateUrl: './users.component.html',
  styleUrls: ['./users.component.css']
})
export class UsersComponent implements OnInit {
  errorMessage: any;
  users: IUser[];
  loaded = false;
  paging = {
    itemsPerPage: environment.itemsPerPage,
    total: 0,
    currentPage: 1
  };
  branches: IBranch[];
  roles = [
    'ROLE_ADMIN',
    'ROLE_ROOT_ADMIN',
    'ROLE_SALES_MANAGER',
    'ROLE_ANALYST',
    'ROLE_HEAD_SALES_MANAGER'
  ];
  usersForm: FormGroup;
  filterProps = {};

  constructor(
    private _userService: UserService,
    private fb: FormBuilder,
    private branchService: BranchService,
    private modalService: NgbModal,
    private helper: Helper
  ) {
    this.branchService.getBranches({}).subscribe(res => {
      this.branches = res.body;
    }, error => (this.errorMessage = <any>error));
  }

  ngOnInit(): void {
    this.getPage(1);
    this.usersForm = this.fb.group({
      id: [''],
      username: [''],
      branch: [''],
      role: ['']
    });
  }

  getPage(page: number, filterProps?: any) {
    this.loaded = false;
    if (filterProps) {
      this.filterProps = filterProps;
    }
    let params = { itemsPerPage: this.paging.itemsPerPage, page: page };
    params = Object.assign(params, this.filterProps);
    this._userService.getUsers(params).subscribe(res => {
      this.paging.total = Number(res.headers.get('X-total-count'));
      this.paging.currentPage = page;
      this.users = res.body;
      this.loaded = true;
    }, error => (this.errorMessage = <any>error));
  }

  addUser() {
    this.editUser(
      {
        id: 0,
        name: null,
        branch: { id: 0 },
        role: null
      },
      -1,
      'add'
    );
  }

  editUser(user, index: number, action = 'edit') {
    const modalRef = this.modalService.open(UserComponent, {
      size: 'lg',
      backdrop: 'static'
      // beforeDismiss: () => confirm(`Are you sure to close form?`)
    });
    modalRef.result.then(
      res => {
        if (action === 'edit') {
          this.users[index] = res;
        } else {
          this.users.push(res);
        }
      },
      reason => {}
    );
    (<UserComponent>modalRef.componentInstance).user = user;
  }

  deleteUser(user): void {
    if (confirm(`Are you sure to delete user ${user.username}?`)) {
      this._userService.deleteUser(user.id).subscribe(val => {
        this.users.splice(this.users.indexOf(user), 1);
        console.log('Deleted user', user.id);
      }, error => (this.errorMessage = <any>error));
    }
  }

  filterTable(): void {
    const formValue = this.usersForm.value;
    for (const key in formValue) {
      if (formValue.hasOwnProperty(key)) {
        const element = formValue[key];
        if (!element) {
          delete formValue[key];
        }
      }
    }

    const FV = this.helper.setPrefix(
      [{ name: 'branch', pre: 'branches/' }],
      formValue
    );
    this.getPage(1, FV);
  }
}



// WEBPACK FOOTER //
// ./src/app/users/list/users.component.ts